<template>
  <div>
    <div v-if="!withAvilableCart">
      Invoice is not available.
      <ejs-button
        type="button"
        v-on:click.native="onBackButtonClick"
        cssClass="e-danger margin-button"
        >Back to My Financial Transactions</ejs-button
      >
    </div>
    <div v-else>
      <div>
        <div tabindex="0" class="e-card">
          <div class="e-card-title">Invoice Checkout</div>
          <div style="padding: 20px">
            <div>
              <h4 class="title-color">Order Information</h4>
            </div>
            <div class="e-card-separator"></div>
            <div class="wrap_address">
              <div class="form-row">
                <div style="width: 20%" class="form-row-input">
                  <ejs-numerictextbox
                    float-label-type="Always"
                    placeholder="Total Amount*"
                    format="C2"
                    :showSpinButton="spin"
                    readonly="true"
                    v-model="totalAmount"
                  />
                </div>
              </div>
              <div class="form-row">
                <div style="width: 15%">
                  <p style="color: black; font-size: 12px">
                    Available Payment Methods:
                  </p>
                </div>
                <div style="width: 75%" class="form-row">
                  <div
                    style="width: 15%"
                    v-for="(payMethod, index) in paymentMethods"
                    :key="index"
                  >
                    <label class="radio-container">
                      <input
                      class="radio-button"
                      :value="payMethod.method"
                      :htmlAttributes="{ value: payMethod.method }"
                      :data-test-search-request-checkout
                      ="`pm${payMethod.method.split(' ').join('')}`"
                      type="radio"
                      v-model="applicationRequestOrder.checkOutMethod"
                      :checked="
                        applicationRequestOrder.checkOutMethod ===
                        payMethod.method
                      "
                      name="pmethod"
                      >
                      <span class="radio-label">{{payMethod.method}}</span>
                    </label>
                  </div>
                </div>
                <div v-if="totalAmount>=4000">
                 <p style="color: red; font-size: 12px">
                  Unfortunately, you have exceeded the credit card limit per transaction.
                  <br>You may select EFT or Cheque as a payment type and follow up with
                  our accounting department directly for further
                  information at accounting@safetycodes.ab.ca or 1-888-413-0099
                  </p>
                </div>
              </div>
              <div class="form-row">
                <ejs-grid
                  :dataSource="this.applicationRequestOrder.invoices"
                  ref="refShoppingCartList"
                  enablePersistence="false"
                  :allowSorting="false"
                  :allowPaging="false"
                >
                  <e-columns>
                    <e-column
                      field="invoiceId"
                      headerText="Invoice ID"
                      textAlign="Left"
                      :isPrimaryKey="true"
                      width="0"
                    ></e-column>
                    <!-- <e-column headerText="Remove"
                        :commands="commands"
                        textAlign="Left"
                        width=" 10%"></e-column> -->
                    <e-column
                      field="invoiceSourceType"
                      headerText="Invoice Type"
                      textAlign="Left"
                      width="15%"
                    ></e-column>
                    <e-column
                      field="status"
                      headerText="Status"
                      textAlign="Left"
                    ></e-column>
                    <e-column
                      field="invoiceNumber"
                      headerText="Invoice Number"
                      textAlign="Left"
                    ></e-column>
                    <e-column
                      field="totalAmount"
                      headerText="Total Fee"
                      format="C2"
                      textAlign="Left"
                    ></e-column>
                    <e-column
                      field="totalLevy"
                      headerText="Total Levy"
                      format="C2"
                      textAlign="Left"
                    ></e-column>
                    <e-column
                      field="invoiceDate"
                      headerText="Invoice Date"
                      textAlign="Left"
                      type="date"
                      format="MMM dd, yyyy"
                    ></e-column>
                  </e-columns>
                </ejs-grid>
              </div>
            </div>
          </div>
          <div v-show="isError" style="margin: 0 15px; line-height: 15px">
            <p ref="refErrorMessage" style="color: red; font-size: 12px"></p>
          </div>
          <div style="text-align: left; margin: 2%">
            <div class="e-card-separator"></div>
            <div class="form-row">
              <div class="form-row-input textbox-width" style="width: 90%">
                <ejs-textbox
                  float-label-type="Always"
                  placeholder="Customer Note"
                  :multiline="true"
                  name="notes"
                  v-model="applicationRequestOrder.notes"
                />
              </div>
            </div>
            <div>
              <h4 class="title-color">Billing Information</h4>
            </div>
            <div class="e-card-separator"></div>
            <div class="form-row">
              <div class="form-row-input textbox-width" style="width: 40%">
                <!-- <scc-input-validator
                  :rules="[requiredRule]"
                  :value="applicationRequestOrder.referencePO"
                  @validate="(v) => (isPOValid = v)"
                > -->
                  <ejs-textbox
                  float-label-type="Always"
                  placeholder="PO"
                  :maxlength="250"
                  required
                  name="PO"
                  v-model="applicationRequestOrder.referencePO"
                />
                <!-- </scc-input-validator> -->
              </div>
            </div>
            <div class="form-row">
              <div
                class="form-row-input separated-textbox-width"
                style="width: 45%"
              >
                <scc-input-validator
                  :rules="[requiredRule]"
                  :value="applicationRequestOrder.firstName"
                  @validate="(v) => (isFirstNameValid = v)"
                >
                  <ejs-textbox
                    float-label-type="Always"
                    placeholder="First Name*"
                    required
                    name="firstname"
                    :maxlength="100"
                    v-model="applicationRequestOrder.firstName"
                  />
                </scc-input-validator>
              </div>
              <div
                class="form-row-input separated-textbox-width"
                style="width: 45%"
              >
                <scc-input-validator
                  :rules="[requiredRule]"
                  :value="applicationRequestOrder.lastName"
                  @validate="(v) => (isLastNameValid = v)"
                >
                  <ejs-textbox
                    float-label-type="Always"
                    placeholder="Last Name*"
                    required
                    name="lastname"
                    :maxlength="100"
                    v-model="applicationRequestOrder.lastName"
                  />
                </scc-input-validator>
              </div>
            </div>
            <div class="form-row">
              <div class="form-row-input textbox-width" style="width: 90%">
                <ejs-textbox
                  float-label-type="Always"
                  placeholder="Company Name"
                  name="company"
                  v-model="applicationRequestOrder.company"
                />
              </div>
            </div>
            <div class="form-row">
              <div
                class="form-row-input separated-textbox-width"
                style="width: 25%"
              >
                <ejs-textbox
                  ref="phone"
                  float-label-type="Always"
                  placeholder="Phone"
                  :value="applicationRequestOrder.phone"
                  :maxlength="12"
                  @input="formatPhoneNumber($event.value)"
                />
              </div>
              <div
                class="form-row-input separated-textbox-width"
                style="width: 30%"
                >
                  <ejs-textbox
                    float-label-type="Always"
                    placeholder="Applicant Email (Read-only)"
                    required
                    name="emailaddress"
                    readonly="true"
                    v-model="applicationRequestOrder.emailAddress"
                  />
              </div>
              <div
                class="form-row-input separated-textbox-width"
                style="width: 35%"
                v-if="!applicationRequestOrder.emailAddress"
              >
                <scc-input-validator
                  :rules="[requiredRule]"
                  :value="applicationRequestOrder.ccto"
                  @validate="(v) => (isEmailAddressValid = v)"
                >
                  <ejs-textbox
                    float-label-type="Always"
                    placeholder="CC To**"
                    required
                    name="emailaddress"
                    v-model="applicationRequestOrder.ccto"
                  />
                </scc-input-validator>
              </div>
              <div
                class="form-row-input separated-textbox-width"
                style="width: 35%"
                v-if="applicationRequestOrder.emailAddress"
              >
                  <ejs-textbox
                    float-label-type="Always"
                    placeholder="CC To"
                    required
                    name="emailaddress"
                    v-model="applicationRequestOrder.ccto"
                  />
              </div>
            </div>
            <div class="form-row">
              <div class="form-row-input textbox-width" style="width: 80%">
                <scc-input-validator
                  :rules="[requiredRule]"
                  :value="applicationRequestOrder.address"
                  @validate="(v) => (isAddressValid = v)"
                >
                  <ejs-autocomplete
                    :dataSource="melissaAddresses"
                    placeholder="Address*: "
                    :fields="addressAutocompleteFields"
                    ref="billingAddressAutocomplete"
                    :minLength="addressAutocompleteMinLength"
                    :filtering="onAddressAutocompleteFiltering"
                    :change="onAddressSelection"
                    float-label-type="Always"
                    cssClass="required"
                    v-model="applicationRequestOrder.address"
                  ></ejs-autocomplete>
                </scc-input-validator>
              </div>
            </div>
            <div class="form-row">
              <div class="form-row-input area-textbox-width">
                <ejs-textbox
                  float-label-type="Always"
                  placeholder="City"
                  name="city"
                  v-model="applicationRequestOrder.city"
                />
              </div>
              <div class="form-row-input area-textbox-width">
                <ejs-dropdownlist
                  float-label-type="Always"
                  :data-source="provinces"
                  sortOrder="Ascending"
                  :fields="provinceFields"
                  v-model="applicationRequestOrder.province"
                  name="province"
                  placeholder="Select a Province"
                >
                </ejs-dropdownlist>
              </div>
              <div class="form-row-input postalcode-textbox-width">
                <ejs-textbox
                  float-label-type="Always"
                  placeholder="Postal Code"
                  name="postcode"
                  v-model="applicationRequestOrder.postCode"
                />
              </div>
            </div>
            <div v-show="isPayByCreditCard">
              <div style="display: flex">
                <h4 class="title-color" style="margin-right: 50%">
                  Payment Details
                </h4>
                <div class="colright50 logos">
                  <img src="@/assets/payments/ca_visa.png" alt="Visa" />
                  <img src="@/assets/payments/ca_mc.png" alt="Mastercard" />
                  <img
                    src="@/assets/payments/ca_amex.png"
                    alt="American Express"
                  />
                  <img
                    src="@/assets/payments/ca_visadebit.png"
                    alt="Visa Debit"
                  />
                  <img
                    src="@/assets/payments/ca_mcdebit.png"
                    alt="Mastercard Debit"
                  />
                </div>
              </div>
              <div class="e-card-separator"></div>
              <div class="form-row">
                <div
                  class="form-row-input separated-textbox-width"
                  style="width: 30%"
                >
                  <ejs-textbox
                    float-label-type="Always"
                    placeholder="Card Holder*"
                    name="cardholdername"
                    required
                    :maxlength="250"
                    v-model="applicationRequestOrder.cardholderName"
                  />
                </div>
                <div
                  class="form-row-input separated-textbox-width"
                  style="width: 30%"
                >
                  <ejs-textbox
                    float-label-type="Always"
                    placeholder="Card Number*"
                    name="maskedpan"
                    required
                    v-model="applicationRequestOrder.maskedPan"
                  />
                </div>
              </div>
              <div class="form-row">
                <div class="form-row-input separated-textbox-width">
                  <ejs-textbox
                    float-label-type="Always"
                    placeholder="Expiry Date* (mm/yy)"
                    required
                    name="expdate"
                    @input="formatExpiryDate($event.value)"
                    :maxlength="5"
                    v-model="applicationRequestOrder.expDate"
                  />
                </div>
                <div class="form-row-input separated-textbox-width">
                  <div style="display: flex; flex-direction: row">
                    <ejs-textbox
                      float-label-type="Always"
                      placeholder="Card Security Code*"
                      name="cvd"
                      v-model="applicationRequestOrder.cvd"
                    />
                    <ejs-button v-on:click.native="onTipMessage">?</ejs-button>
                  </div>
                </div>
              </div>
            </div>
            <div v-show="isPayByCredit">
              <div style="display: flex">
                <h4 class="title-color" style="margin-right: 50%">
                  Payment Details
                </h4>
              </div>
              <div class="e-card-separator"></div>
              <div class="form-row">
                <div
                  class="form-row-input separated-textbox-width"
                  style="width: 30%"
                >
                <p>Your application has been submitted for processing in priority order. </p>
                </div>
              </div>
            </div>
            <div v-show="isPayByCheck">
              <div style="display: flex">
                <h4 class="title-color" style="margin-right: 50%">
                  Payment Details
                </h4>
              </div>
              <div class="e-card-separator"></div>
              <div class="form-row">
                <div
                  class="form-row-input separated-textbox-width"
                  style="width: 80%"
                >
                  <p>Application will be submitted once payment has been received.</p>
                  <p>Please make cheques payable to Safety Codes Council.</p>
                  <p>If you would like to pay by EFT, please contact accounting@safetycodes.ab.ca
                    for EFT information.</p>
                  <p>Please note: Safety Codes Council does not accept e-transfers.</p>

                </div>
              </div>
            </div>
            <div class="e-card-separator"></div>
            <div style="text-align: right">
              <!-- <ejs-button cssClass="e-info"
                  v-on:click.native="onSubmit">Process Transaction</ejs-button> -->
              <form @submit.prevent="onSubmit">
                <ejs-progressbutton
                  ty
                  :content="content"
                  type="submit"
                  ref="progressbutton"
                  cssClass="e-info"
                  style="height: 35px; width: 40%"
                  :enableProgress="true"
                  :animationSettings="animationSettings"
                  :begin="begin"
                  :end="end"
                  :click="onSubmit"
                  :duration="duration"
                  data-test-search-request-checkout="pt"
                ></ejs-progressbutton>
              </form>
              <ejs-button
                cssClass="e-danger"
                style="height: 35px; width: 10%; margin: 10px"
                v-on:click.native="onCancelClick"
                >Cancel</ejs-button
              >
            </div>
            <div v-show="showTip">
              <fieldset>
                <legend>Help Message</legend>
                <p ref="refTipMessage"></p>
              </fieldset>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import {
  GridPlugin,
  Page,
  Toolbar,
  Edit,
  CommandColumn,
  Sort,
  Search,
} from '@syncfusion/ej2-vue-grids';

import {
  TextBoxPlugin,
  MaskedTextBoxPlugin,
  NumericTextBoxPlugin,
} from '@syncfusion/ej2-vue-inputs';
import { ButtonPlugin, RadioButtonPlugin } from '@syncfusion/ej2-vue-buttons';
import { DialogUtility } from '@syncfusion/ej2-popups';
import {
  DropDownListPlugin,
  AutoCompletePlugin,
} from '@syncfusion/ej2-vue-dropdowns';
import { ProgressButtonPlugin } from '@syncfusion/ej2-vue-splitbuttons';
import {
  GET_MELISSA_ADDRESSES,
  GET_PROVINCES,
} from '@/modules/user-accounts/store';
import {
  FETCH_INVOICE_BY_REQUEST_ID,
  FETCH_INVOICE_PAYMENT_METHODS,
  REQUEST_PAY,
} from '../store';
import appConfig from '../../../app.config';
import SccInputValidator from '../../../components/base/scc-input-validator.vue';

Vue.use(GridPlugin);
Vue.use(TextBoxPlugin);
Vue.use(RadioButtonPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(MaskedTextBoxPlugin);
Vue.use(ButtonPlugin);
Vue.use(AutoCompletePlugin);
Vue.use(DropDownListPlugin);
Vue.use(ProgressButtonPlugin);
Vue.use(DialogUtility);

export default {
  name: 'PayByRequest',
  components: {
    SccInputValidator,
  },
  data() {
    return {
      spin: false,
      totalAmount: 0,
      invoiceToRemove: null,
      DialogObj: null,
      user: null,
      userCompany: null,
      provinces: [],
      melissaAddresses: [],
      addressAutocompleteMinLength: 3,
      addressAutocompleteFields: {
        value: 'Address.Address1',
        text: 'Address.Address',
      },
      melissaAddress1: '',
      melissaCountry: 'CA',
      showTip: false,
      returnOrder: null,
      requiredRule: {
        regEx: '^(?!\\s*$).+',
        message: 'This field is required',
      },
      isError: false,
      // isPOValid: false,
      isFirstNameValid: false,
      isLastNameValid: false,
      isEmailAddressValid: false,
      isAddressValid: false,
      provinceFields: {
        text: 'provinceName',
        value: 'provinceName',
        groupBy: 'countryName',
      },
      position: { X: 'Right', Y: 'Top' },
      applicationRequestOrder: {
        firstName: '',
        lastName: '',
        company: '',
        address: '',
        city: '',
        province: '',
        postCode: '',
        country: 'Canada',
        phone: '',
        fax: '',
        emailAddress: '',
        maskedPan: '',
        cvd: '',
        expDate: '',
        cardholderName: '',
        notes: '',
        checkOutMethod: null,
        invoices: [],
        referencePO: '',
        ccto: '',
      },
      animationSettings: { effect: 'SlideUp', duration: 500, easing: 'linear' },
      spinSettings: { position: 'Center' },
      content: 'Process Transaction',
      duration: 6500,
      dateMarker: 'Expiry Date:',
      dateFormat: 'yyyy-MM-dd',
      tooltipPosition: 'top left',
      tooltipContent:
        '<h3 class="cvdTitle" id="cvdTitleId">CVD - Card Validation Digits</h3><h4 class="cvdSubtitle">Visa, Mastercard and Gift Cards</h4>'
        + '<div class="cvdText">The CVD appears on the back your credit card, it is the last three digits printed on the signature panel. These digits should not appear anywhere else on the card.</div>'
        + '<h4 class="cvdSubtitle">American Express</h4>'
        + '<div class="cvdText">The CVD appears on the front of your credit card.  It is the printed four digits that appear above and to the right of the embossed card number.  On OPTIMA cards the CVD appears above and to the left of the embossed card number.</div>',
    };
  },
  created() {
    if (
      this.$route.params.requestId !== null
      && this.$route.params.requestId !== undefined
    ) {
      this.getProvinces();
      this.getInvoiceBySearchRequestId(this.$route.params.requestId).then(
        () => {
          this.invoice = this.$store.getters.getInvoiceByRequestId;
          if (this.invoice) {
            this.applicationRequestOrder.requestId = this.$route.params.requestId;
            this.applicationRequestOrder.checkOutMethod = '';
            this.applicationRequestOrder.invoices.push(this.invoice);
            if (this.invoice.referencePO) {
              this.applicationRequestOrder.referencePO = this.invoice.referencePO;
              // this.isPOValid = true;
            } else {
              this.applicationRequestOrder.referencePO = null;
              // this.isPOValid = false;
            }
            if (this.invoice.applicationRequest.requestUserEmail) {
              // eslint-disable-next-line max-len
              this.applicationRequestOrder.emailAddress = this.invoice.applicationRequest.requestUserEmail;
              this.isEmailAddressValid = true;
            } else {
              this.applicationRequestOrder.emailAddress = '';
              this.isEmailAddressValid = false;
            }
            // eslint-disable-next-line max-len
            this.totalAmount = this.invoice.applicationRequest.totalAmount
              + this.invoice.applicationRequest.totalLevy;
            if (appConfig.env !== 'PROD') {
              this.applicationRequestOrder.maskedPan = '5454545454545454';
              this.applicationRequestOrder.cardholderName = 'LEO XU';
              this.applicationRequestOrder.expDate = '01/22';
              this.applicationRequestOrder.cvd = '099';
              this.applicationRequestOrder.notes = 'Leo test Search Request Guest Payment.';
            }
            if (this.invoice.applicationRequest.firstName) {
              this.applicationRequestOrder.firstName = this.invoice.applicationRequest.firstName;
              this.isFirstNameValid = true;
            } else {
              this.applicationRequestOrder.firstName = '';
              this.isFirstNameValid = false;
            }
            if (this.invoice.applicationRequest.lastName) {
              this.applicationRequestOrder.lastName = this.invoice.applicationRequest.lastName;
              this.isLastNameValid = true;
            } else {
              this.applicationRequestOrder.lastName = '';
              this.isLastNameValid = false;
            }
            this.applicationRequestOrder.company = this.invoice.applicationRequest.company;
            // console.log('this.invoice.applicationRequest.billingAddress'
            // , this.invoice.applicationRequest.billingAddress)
            if (this.invoice.applicationRequest.billingAddress) {
              this.applicationRequestOrder.address = this.invoice.applicationRequest.billingAddress;
              this.isAddressValid = true;
            } else {
              this.applicationRequestOrder.address = '';
              this.isAddressValid = false;
            }
            this.applicationRequestOrder.city = this.invoice.applicationRequest.city;
            this.applicationRequestOrder.province = this.invoice.applicationRequest.province;
            this.applicationRequestOrder.postCode = this.invoice.applicationRequest.postalCode;
            this.applicationRequestOrder.phone = this.invoice.applicationRequest.phoneNumber;
            this.getPymentMethods(this.invoice.invoiceId);
          } else {
            this.notify(
              'Error',
              'Invoice not ready for payment, or it already paid!',
            );
          }
        },
      );
    }
  },
  computed: {
    userId() {
      return this.$store.getters.loggedUser
        ? this.$store.getters.loggedUser.id
        : null;
    },
    paymentMethods() {
      return this.$store.getters.getInvoicePaymentMethods;
    },
    isPayByCreditCard() {
      return this.applicationRequestOrder.checkOutMethod === 'Credit Card';
    },
    isPayByCredit() {
      return this.applicationRequestOrder.checkOutMethod === 'Credit';
    },
    isPayByCheck() {
      return this.applicationRequestOrder.checkOutMethod === 'Cheque' || this.applicationRequestOrder.checkOutMethod === 'EFT';
    },
    withAvilableCart() {
      return this.totalAmount > 0;
    },
    isLoggedUserAdmin() {
      return (
        this.isCurrentUserInRole('admin')
        || this.isCurrentUserInRole('superadmin')
        || this.isCurrentUserInRole('accounting')
      );
    },
    isUserLogged() {
      return !!this.$store.getters.loggedUser;
    },
  },
  methods: {
    isCurrentUserInRole(roleName) {
      let roleIndex = -1;
      const LogedUser = this.$store.getters.loggedUser;
      if (LogedUser && LogedUser.roles) {
        roleIndex = LogedUser.roles.findIndex(
          (r) => r.roleName.toLowerCase() === roleName,
        );
      }
      return roleIndex >= 0;
    },
    formatPhoneNumber(val) {
      if (val?.length === 10 && parseInt(val, 0) && !val.includes('-')) {
        this.applicationRequestOrder.phone = `${val.slice(0, 3)}-${val.slice(3, 6)}-${val.slice(6)}` ?? null;
      } else {
        this.applicationRequestOrder.phone = val ?? null;
      }
    },
    formatExpiryDate(val) {
      if (val?.length === 4 && parseInt(val, 0) && !val.includes('/')) {
        this.applicationRequestOrder.expDate = `${val.slice(0, 2)}/${val.slice(2, 4)}` ?? null;
      } else {
        this.applicationRequestOrder.expDate = val ?? null;
      }
    },
    notify(type, message) {
      this.$parent.$parent.notificationToasts.push({
        title: type,
        content: message,
        cssClass: type === 'Error' ? 'e-toast-danger' : 'e-toast-success',
        timeOut: 5000,
      });
      if (this.$parent.$parent.notificationToasts.length > 0) {
        this.$parent.$parent.$refs.notifierRef.show();
      }
    },
    onBackButtonClick() {
      this.$router.push('/reports/transactions');
    },
    async getProvinces() {
      try {
        await this.$store.dispatch(GET_PROVINCES);
        this.provinces = this.$store.getters.provinces;
      } catch (err) {
        console.error(err);
      }
    },
    async getInvoiceBySearchRequestId(requestId) {
      try {
        await this.$store.dispatch(FETCH_INVOICE_BY_REQUEST_ID, requestId);
      } catch (error) {
        this.notify('Error', error.message);
      }
    },
    onTipMessage() {
      this.$refs.refTipMessage.innerHTML = this.tooltipContent;
      this.showTip = !this.showTip;
    },
    onCancelClick() {
      this.DialogObj = DialogUtility.confirm({
        title: 'Cancel Payment',
        content:
          'Are you sure you want to exit the payment process?<br> You can make the payment later from the "My Financial Transactions" page.',
        okButton: { text: 'OK', click: this.cancelProcess },
        cancelButton: { text: 'Cancel', click: this.hideDeleteDialog },
        showCloseIcon: true,
        closeOnEscape: true,
        animationSettings: { effect: 'Zoom' },
      });
    },
    cancelProcess() {
      if (!this.isUserLogged) {
        this.$router.push('/'); // reports/transactions
      } else {
        this.$router.push('/reports/transactions');
      }
      this.DialogObj.hide();
    },
    async getPymentMethods(invoiceId) {
      try {
        await this.$store.dispatch(FETCH_INVOICE_PAYMENT_METHODS, invoiceId);
      } catch (error) {
        this.notify('Error', error.message);
      }
    },
    async getMelissaAddresses() {
      try {
        const { melissaCountry } = this;
        const { address: melissaAddress1 } = this.applicationRequestOrder;
        await this.$store.dispatch(GET_MELISSA_ADDRESSES, {
          melissaAddress1,
          melissaCountry,
        });
        this.melissaAddresses = this.$store.getters.melissaAddresses;
      } catch (err) {
        console.error(err);
      }
    },
    onAddressAutocompleteFiltering(e) {
      e.preventDefaultAction = true;
      if (
        e.text.length
        >= this.$refs.billingAddressAutocomplete.ej2Instances.minLength
      ) {
        this.$refs.billingAddressAutocomplete.ej2Instances.showSpinner();
        this.applicationRequestOrder.address = e.text;
        // this.melissaCountry = this.$refs.country.ej2Instances.value;
        const { melissaCountry } = this;
        const { address: melissaAddress1 } = this.applicationRequestOrder;
        this.$store
          .dispatch(GET_MELISSA_ADDRESSES, {
            melissaAddress1,
            melissaCountry,
          })
          .then(() => {
            e.updateData(this.$store.getters.melissaAddresses);
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    onAddressSelection(e) {
      const { itemData } = e;

      if (itemData && itemData.Address) {
        this.applicationRequestOrder.address = itemData.Address.DeliveryAddress;

        this.applicationRequestOrder.city = itemData.Address.SubAdministrativeArea
          || itemData.Address.Locality
          || '';
        this.applicationRequestOrder.province = itemData.Address.AdministrativeArea || '';
        this.applicationRequestOrder.postCode = itemData.Address.PostalCode || '';
        this.$refs.billingAddressAutocomplete.$el.value = itemData.Address.DeliveryAddress;
      } else {
        this.applicationRequestOrder.city = '';
        this.applicationRequestOrder.province = null;
        this.applicationRequestOrder.postCode = '';
      }
    },
    begin() {
      this.content = 'Loading...';
    },
    end() {
      this.content = 'Process Transaction';
      this.duration = 25000;
    },
    async onSubmit() {
      this.duration = 25000;
      try {
        this.isError = false;
        let notificationContent = '<b>Please double check required fields:</b>';
        if (this.totalAmount <= 0) {
          notificationContent += '<li>Total Amount must > 0.</li>';
          this.isError = true;
        }
        if (
          this.applicationRequestOrder.checkOutMethod === null
          || this.applicationRequestOrder.checkOutMethod === ''
        ) {
          notificationContent += '<li>Payment method is required.</li>';
          this.isError = true;
        }
        // if (!this.isPOValid) {
        //   notificationContent += '<li>PO is required.</li>';
        //   this.applicationRequestOrder.referencePO = '';
        //   this.isError = true;
        // }
        if (!this.isFirstNameValid) {
          notificationContent += '<li>First Name Missing.</li>';
          this.isError = true;
        }
        if (!this.isLastNameValid) {
          notificationContent += '<li>Last Name Missing.</li>';
          this.isError = true;
        }
        if (!this.applicationRequestOrder.emailAddress && !this.isEmailAddressValid) {
          notificationContent += '<li>CC To Email Missing.</li>';
          this.isError = true;
        }
        if (!this.isAddressValid) {
          notificationContent += '<li>Address Missing.</li>';
          this.isError = true;
        }
        if (this.applicationRequestOrder.checkOutMethod === 'Credit Card') {
          if (!this.applicationRequestOrder.cardholderName) {
            notificationContent += '<li>Card Holder Missing.</li>';
            this.isError = true;
          }
          if (!this.applicationRequestOrder.maskedPan) {
            notificationContent += '<li>Card Number Missing.</li>';
            this.isError = true;
          }
          if (!this.applicationRequestOrder.expDate) {
            notificationContent += '<li>Expiry Date Missing.</li>';
            this.isError = true;
          } else if (this.applicationRequestOrder.expDate.length !== 5) {
            notificationContent += '<li>Expiry Date Format Wrong.</li>';
            this.isError = true;
          }
          if (!this.applicationRequestOrder.cvd) {
            notificationContent += '<li>Card Security Code Missing.</li>';
            this.isError = true;
          }
        }
        if (this.isError) {
          this.duration = 2000;
          this.content = 'Validation Error ....';
          this.$refs.refErrorMessage.innerHTML = notificationContent;
          this.notify('Error', notificationContent);
          return;
        }
        const order = this.applicationRequestOrder;
        const resp = await this.$store.dispatch(REQUEST_PAY, order);
        this.returnOrder = resp;
        this.notify('Success', 'Payment made successfully');
        this.$router.push({
          name: 'Receipt',
          params: {
            id: this.returnOrder,
          },
        });
      } catch (error) {
        this.notify('Error', error.response.data.message);
      }
    },
  },
  provide: {
    grid: [Page, Edit, Toolbar, CommandColumn, Sort, Search],
  },
};
</script>
<style>
@import "../../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css";
@import "../../../assets/styles/eservices-base.css";
.scc-logo {
  float: left;
}
.header-text {
  text-align-last: center;
  padding: 13px 130px 8px 8px;
}

.radio-container {
  font-family: "Roboto", "Segoe UI", "GeezaPro"
  , "DejaVu Serif", "sans-serif", "-apple-system", "BlinkMacSystemFont";
  display: flex;
  justify-content: center;
  align-items: center;
}
.radio-button {
  width: 19px;
  height: 19px;
  accent-color: #0F4B90;
}
.radio-label {
  font-size: 12px;
  margin-left: 4px;;
}
</style>
